import ScrollReveal from "@/components/ScrollReveal";

const clientTypes = [
  "Sovereign Wealth Funds",
  "Central Banks",
  "Family Offices",
  "Tier-1 Custodians",
  "Regulated Exchanges",
  "Institutional Allocators",
];

export default function ClientBar() {
  return (
    <section
      data-testid="client-bar"
      className="py-20 md:py-24 px-6 md:px-12 border-y border-slate-800"
    >
      <div className="max-w-7xl mx-auto">
        <ScrollReveal>
          <p className="text-center text-[10px] tracking-[0.25em] uppercase text-slate-600 mb-10">
            Trusted by leading institutional stakeholders
          </p>
        </ScrollReveal>
        <ScrollReveal delay={0.1}>
          <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-4">
            {clientTypes.map((client, i) => (
              <div key={client} className="flex items-center gap-4">
                {i > 0 && <span className="hidden md:block w-px h-4 bg-slate-800" />}
                <span className="text-xs tracking-[0.1em] text-slate-500 hover:text-slate-300 transition-colors duration-300">
                  {client}
                </span>
              </div>
            ))}
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}
